import React, { InputHTMLAttributes } from "react";

// =============================================================================
// INPUT
// =============================================================================
// PURPOSE: Text input with label.
// =============================================================================

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}

const Input: React.FC<InputProps> = ({ label, error, className = "", ...props }) => {
  return (
    <div className="w-full">
      {label && (
        <label htmlFor={props.id} className="block text-sm font-normal text-glass-secondary mb-1.5">
          {label}
        </label>
      )}
      <input
        className={`w-full bg-black/[0.05] border border-black/[0.12] text-glass rounded-xl px-4 py-2.5 font-normal placeholder:text-glass-tertiary transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-black/[0.03] disabled:text-glass-tertiary ${error ? "border-red-500 focus:ring-red-500" : ""} ${className}`}
        {...props}
      />
      {error && <p className="mt-1 text-sm text-red-500">{error}</p>}
    </div>
  );
};

export default Input;
